import React from 'react';
import { Trash2, Check, FileText } from 'lucide-react';
import { Resume } from '@/api/types';

interface LibraryItemProps {
  resume: Resume;
  isSelected: boolean;
  onSelect: (id: string) => void;
  onDelete: (id: string) => void;
}

export const LibraryItem = ({ resume, isSelected, onSelect, onDelete }: LibraryItemProps) => {
  return (
    <div
      className={`flex items-center justify-between p-2.5 cursor-pointer group ${
        isSelected ? 'bg-emerald-50/50 dark:bg-slate-800/80 dark:shadow-[inset_2px_0_0_0_rgba(16,185,129,1)]' : 'hover:bg-slate-50/50 dark:hover:bg-slate-800/40 border-transparent'
      }`}
      onClick={() => onSelect(resume.id)}
    >
      <div className="flex items-center gap-2 overflow-hidden">
        <div className={`p-1.5 rounded bg-white dark:bg-slate-950 shrink-0 border border-slate-200 dark:border-slate-800 text-slate-900 dark:text-white`}>
          <FileText className="w-3.5 h-3.5" />
        </div>
        <div className="overflow-hidden flex flex-col">
          <div className={`text-xs truncate pr-2 ${isSelected ? 'font-medium text-slate-900 dark:text-white' : 'font-medium text-slate-700 dark:text-slate-400 group-hover:text-slate-900 dark:group-hover:text-slate-200'}`}>
            {resume.label}
          </div>
        </div>
      </div>
      <div className="flex items-center gap-1 pl-2 shrink-0">
        {isSelected && <Check className="w-3.5 h-3.5 text-slate-900 dark:text-white mr-1" />}
        {resume.contentBase64 && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              const byteCharacters = atob(resume.contentBase64!);
              const byteNumbers = new Array(byteCharacters.length);
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              const byteArray = new Uint8Array(byteNumbers);
              const blob = new Blob([byteArray], {type: 'application/pdf'});
              const url = URL.createObjectURL(blob);
              window.open(url, '_blank');
            }}
            className="p-1.5 text-slate-500 dark:text-slate-600 hover:text-emerald-600 dark:hover:text-emerald-400 hover:bg-emerald-50 dark:hover:bg-emerald-900/20 rounded focus:outline-none cursor-pointer"
            aria-label={`View ${resume.label}`}
            title="View original file"
          >
            <FileText className="w-3.5 h-3.5" />
          </button>
        )}
        <button
          onClick={(e) => {
            e.stopPropagation();
            onDelete(resume.id);
          }}
          className={`p-1.5 text-slate-500 dark:text-slate-600 hover:text-red-600 dark:hover:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 rounded focus:outline-none cursor-pointer ${isSelected ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`}
          aria-label={`Delete ${resume.label}`}
        >
          <Trash2 className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
};
